const mutations = {
  setCediGroup(state, data) {
    state.cedigroupEdit = data
  },
  setDeleteCediGroup(state, data) {
    state.cedigroupDelete = data
  }
}

export default mutations